// CommonCalendar.tsx
import React from "react";
import { Calendar, Badge } from "antd";

interface CalendarEvent {
    date: string; // Format: "YYYY-MM-DD"
    type: string; // A = Attendance, W = Weekend
    content: string;
}

interface CommonCalendarProps {
    events: CalendarEvent[];
    dateRender?: (date: any) => React.ReactNode;
}

const CommonCalendar: React.FC<CommonCalendarProps> = ({ events, dateRender }) => {
    const getListData = (date: moment.Moment) => {
        const currentDate = date.format("YYYY-MM-DD");
        return events.filter((event) => event.date === currentDate);
    };

    const dateCellRender = (date) => {
        const listData = getListData(date);
        return (
            <ul className="events">
                {listData.map((item, index) => (
                    <li key={index}>
                        <Badge
                            status={item.type === "A" ? "error" : "success"}
                            text={item.content}
                        />
                    </li>
                ))}
            </ul>
        );
    };

    return <Calendar
        fullscreen={false}
        cellRender={(e) => dateRender ? dateRender(e) : dateCellRender(e)}
    />;
};

export default CommonCalendar;
